import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { http, getWs, WS_KEY } from "@/lib/http";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [workspaces, setWorkspaces] = useState([]);
  const [wsId, setWsId] = useState(getWs());

  const apply = useCallback((data, preferWs) => {
    setUser(data.user);
    setWorkspaces(data.workspaces);
    if (data.csrf_token) localStorage.setItem("csrf_token", data.csrf_token);
    const want = preferWs || getWs();
    const pick = data.workspaces.find((w) => w.id === want) || data.workspaces[0];
    if (pick) {
      localStorage.setItem(WS_KEY, pick.id);
      setWsId(pick.id);
    }
  }, []);

  const loadMe = useCallback(() => http.get("/auth/me").then((r) => apply(r.data)).catch(() => setUser(false)), [apply]);

  useEffect(() => {
    loadMe();
    const out = () => setUser(false);
    window.addEventListener("mh-logout", out);
    return () => window.removeEventListener("mh-logout", out);
  }, [loadMe]);

  const login = async (email, password) => apply((await http.post("/auth/login", { email, password })).data);
  const acceptInvite = async (payload) => {
    const { data } = await http.post("/auth/accept-invite", payload);
    apply(data, data.workspace_id);
  };
  const logout = async () => {
    await http.post("/auth/logout").catch(() => {});
    localStorage.removeItem(WS_KEY);
    localStorage.removeItem("csrf_token");
    setUser(false);
  };
  const switchWorkspace = (id) => {
    localStorage.setItem(WS_KEY, id);
    window.location.assign("/");
  };

  const current = workspaces.find((w) => w.id === wsId);
  const role = current?.role || "viewer";
  const value = {
    user, workspaces, current, role, login, logout, acceptInvite, switchWorkspace, reload: loadMe,
    isAdmin: !!user?.is_agency_admin, canManage: role === "owner" || role === "manager", isOwner: role === "owner",
  };
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
